import React, { Fragment } from 'react';
import Backdrop from '../UI/Backdrop/Backdrop';
import ListItem from '../UI/ListItem/ListItem';
import ZeroResult from '../UI/ZeroResult/ZeroResult';
import SideMenuItem from '../Navigation/LeftSidebar/SideMenuItem/SideMenuItem';
import TabsWrapper from '../Layout/TabsWrapper/TabsWrapper';
import classes from './FakeBackground.module.css';
import strings from '../../assets/localization';
import lp1 from '../../assets/images/lp1.webp';
import lp2 from '../../assets/images/lp2.webp';
import lp3 from '../../assets/images/lp3.webp';
import lp4 from '../../assets/images/lp4.webp';
import lp5 from '../../assets/images/lp5.webp';
import lp6 from '../../assets/images/lp6.webp';

const FakeBackground = (props) => {
  // dummy background content
  const TEST_USERS = [
    {
      gender: 3,
      username: 'Dale',
      dob: '1989-04-24',
      city: 'New York',
      online: true,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp1 }, {}, {}],
      currentUser: { country: 'US' },
    },
    {
      gender: 3,
      username: 'Kit',
      dob: '1995-02-24',
      city: 'New York',
      online: true,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp2 }],
      currentUser: { country: 'US' },
    },
    {
      gender: 3,
      username: 'Ollie',
      dob: '1994-03-24',
      city: 'New York',
      online: false,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp3 }],
      currentUser: { country: 'US' },
    },
    {
      gender: 3,
      username: 'Vic',
      dob: '1969-12-24',
      city: 'New York',
      online: false,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp4 }],
      currentUser: { country: 'US' },
    },
    {
      gender: 3,
      username: 'Jem',
      dob: '1972-12-24',
      city: 'New York',
      online: false,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp5 }, {}, {}, {}],
      currentUser: { country: 'US' },
    },
    {
      gender: 3,
      username: 'Lonnie',
      dob: '1949-12-24',
      city: 'New York',
      online: false,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp6 }, {}, {}, {}, {}],
      currentUser: { country: 'US' },
    },
    {
      gender: 3,
      username: 'Fran',
      dob: '1991-04-24',
      city: 'New York',
      online: true,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp1 }],
      currentUser: { country: 'US' },
    },
    {
      gender: 3,
      username: 'Kit',
      dob: '1997-02-24',
      city: 'New York',
      online: true,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp2 }, {}, {}],
      currentUser: { country: 'US' },
    },
    {
      gender: 3,
      username: 'Jo',
      dob: '1966-03-24',
      city: 'New York',
      online: false,
      country: 'US',
      state: 'NY',
      images: [{ thumb: lp3 }, {}],
      currentUser: { country: 'US' },
    },
  ];
  let leftSide = null;
  let rightSide = null;
  if (props.isLandscape) {
    leftSide = (
      <div className={classes.LeftSidebar}>
        <div className={classes.LeftSidebarHeaderWrapper}>
          <div className={classes.LeftSidebarHeader}>
            <svg className={classes.LeftSidebarHeaderIcon}>
              <use xlinkHref='#icon-logo' />
            </svg>
          </div>
        </div>
        <nav className={classes.LeftSidebarBody}>
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-hearts-filled'
            fill='var(--svg-color-hearts-filled-sidebar)'
            strings={strings.Matches}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-heart-likes-filled'
            fill='var(--svg-color-heart-likes-filled-sidebar)'
            counter={0}
            strings={strings.Likes}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-lighting-bolt'
            fill='var(--svg-color-lighting-bolt-sidebar)'
            strings={strings.QuickMatch}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-view'
            fill='var(--svg-color-view-sidebar)'
            counter={0}
            strings={strings.ViewedMyProfile}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-search-bold'
            fill='var(--svg-color-search-bold-sidebar)'
            strings={strings.Search}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-online'
            fill='var(--svg-color-online-sidebar)'
            strings={strings.WhosOnline}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-star-filled'
            fill='var(--svg-color-star-filled-sidebar)'
            counter={0}
            strings={strings.Favorites}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-browse'
            fill='var(--svg-color-browse-sidebar)'
            strings={strings.Browse}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-profile'
            fill='var(--svg-color-profile-sidebar)'
            strings={strings.MyProfile}
            to=''
            clicked={() => {}}
          />
          <SideMenuItem
            className={classes.SideMenuElement}
            img='/sprites.svg#icon-settings'
            fill='var(--svg-color-settings-sidebar)'
            strings={strings.Settings}
            to=''
            clicked={() => {}}
          />
        </nav>
      </div>
    );
    rightSide = (
      <div className={classes.RightSidebar}>
        <div className={classes.ChatsHeaderWrapper}>
          <div className={classes.ChatsHeader}>{strings.Chat}</div>
        </div>
        <div className={classes.Chats}>
          <TabsWrapper
            tabNavTitles={[strings.chats, strings.sentMessages]}
            tabRoutes={['', '']}
            components={[]}
            dots={[false, false]}
            withRouting={!props.isLandscape}
            match={props.computedMatch}
            history={props.history}
            squared={false}
            setActiveTab={props.setActiveTab}
            tabsNavWrapperStyle={{
              justifyContent: 'flex-start',
              marginLeft: '-0.5rem',
            }}
            tabsNavStyle={{ width: 'calc(100% - 1rem)' }}
          />
        </div>
        <ZeroResult
          headerTitle={`${strings.youHave} 0 ${strings.chats}`}
          subTitle={strings.yourConversations}
          sex={3}
          buttonClick={() => {}}
        />
        ;
      </div>
    );
  }

  const centerComponent = (
    <div className={classes.CenterBar}>
      <div className={classes.CenterBarHeaderWrapper}>
        <div className={classes.CenterBarHeader}>{strings.Matches}</div>
        <div className={classes.userListWrapper}>
          <div className={classes.userList}>
            {TEST_USERS.map((user, i) => (
              <ListItem key={i} user={user} currentUser={user.currentUser} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      <div className={classes.Wrapper}>
        <Backdrop />
        {leftSide}
        {centerComponent}
        {rightSide}
      </div>
    </Fragment>
  );
};

export default FakeBackground;
